import { Box, styled, Typography } from '@mui/material';

export const QuestionsContainerItem = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutral[100],
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
}));

export const QuestionsContainerItemYesNoContainer = styled(Box)(
  ({ theme }) => ({
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.common.white,

    padding: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    borderRadius: theme.shape.borderRadius,
    '.MuiRadioGroup-root': {
      flexDirection: 'row',
      gap: theme.spacing(3),
      justifyContent: 'flex-start',
      alignItems: 'center',
    },

    '.MuiFormControlLabel-root': {
      margin: 0,
      alignItems: 'center',

      '&:not(:last-child)': {
        marginRight: theme.spacing(3),
      },
    },
  }),
);

export const QuestionLabel = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  marginTop: theme.spacing(2),
}));

export const FormFieldContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));
